import { Field } from "formik";
import { registerWidget } from "./registry";

export const toggleFormField = (config: any, formikParams: any) => {
  const extraProps = config ?? {};
  if (formikParams.handleChange != null)
    extraProps["onChange"] = formikParams.handleChange;
  if (formikParams.readOnly != null)
    extraProps["readOnly"] = formikParams.readOnly;
  return (
    <Field
      {...extraProps}
      name={config.name}
      type="checkbox"
      className={`form-check-input`}
      onInvalid={(e: any) => e.target.setCustomValidity('Your custom message')}
      required={undefined}
      id={config.name}
    />
  );
};

registerWidget("boolean", toggleFormField);
